import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import StatusBadge from "./StatusBadge";
import { fmtDate, fmtDateTime } from "@/lib/utils2";
import { HeartPulse } from "lucide-react";

export default function RequestsTable({ rows, onOpen, emptyMessage = "No requests yet." }) {
  if (!rows?.length) {
    return <div className="text-sm text-muted-foreground py-12 text-center border border-dashed border-border rounded-lg">{emptyMessage}</div>;
  }
  const isSickness = (r) => (r.request_type || "").toLowerCase() === "sickness";
  return (
    <div className="border border-border rounded-lg overflow-hidden bg-[#1E1E1E]">
      <Table data-testid="requests-table">
        <TableHeader>
          <TableRow className="bg-[#141414]">
            <TableHead>Contractor</TableHead>
            <TableHead>Department</TableHead>
            <TableHead>Site</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Dates</TableHead>
            <TableHead className="text-right">Days</TableHead>
            <TableHead>Supervisor</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Submitted</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow
              key={r.id}
              data-testid={`row-request-${r.id}`}
              data-request-type={r.request_type}
              onClick={() => onOpen?.(r)}
              className={`cursor-pointer hover:bg-[#141414] ${isSickness(r) ? "bg-rose-950/20 hover:bg-rose-950/30" : ""}`}
            >
              <TableCell className="font-medium">{r.first_name} {r.last_name}<div className="text-xs text-muted-foreground">{r.email}</div></TableCell>
              <TableCell>{r.department}</TableCell>
              <TableCell className="text-muted-foreground">{r.site || "—"}</TableCell>
              <TableCell>{r.job_role}</TableCell>
              <TableCell>
                {isSickness(r) ? (
                  <span
                    data-testid={`sickness-badge-${r.id}`}
                    className="inline-flex items-center gap-1 rounded-full border border-rose-600 bg-rose-950/60 text-rose-200 text-[10px] font-semibold uppercase tracking-wider px-2 py-0.5"
                  >
                    <HeartPulse className="w-3 h-3"/> Sickness
                  </span>
                ) : (
                  <span className="text-xs text-muted-foreground">Absence</span>
                )}
              </TableCell>
              <TableCell className="whitespace-nowrap">{fmtDate(r.start_date)} → {fmtDate(r.end_date)}</TableCell>
              <TableCell className="text-right tabular-nums">{r.days}</TableCell>
              <TableCell>{r.supervisor_name}</TableCell>
              <TableCell><StatusBadge status={r.status} /></TableCell>
              <TableCell className="text-muted-foreground text-xs whitespace-nowrap">{fmtDateTime(r.submitted_at)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
